import ajax from '@client/components/ajax'; // NOTE: old
import { LiteUser } from '@client/new/common/LiteUser.mapper';

import { TextField } from '@client/new/components/basic';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { PrimaryButton } from '@client/new/components/button';
import { TikTokConfiguration } from '@client/new/hooks/use-user';
import { InfoTip } from '../InfoTip';
import { mixTrack } from '@services/mixpanel';

export const TikTokForm = (p: { creator: LiteUser }) => {
  const [state, setState] = useState<TikTokConfiguration>(
    p.creator.tikTokConfiguration ?? { pixelId: '', apiSecret: '' },
  );
  const [isSaving, setIsSaving] = useState(false);

  const submit = () => {
    setIsSaving(true);

    mixTrack({
      type: 'TikTok Configuration Saved',
      payload: {},
    });

    ajax
      .upsertInfluencer({
        ...(p.creator as any),
        tikTokConfiguration: state,
      })
      .then(() => toast.success('TikTok configuration was saved!'))
      .catch((err) =>
        toast.error('Error saving TikTok configuration: ' + err.message),
      )
      .finally(() => setIsSaving(false));
  };

  return (
    <div className="flex flex-col gap-5 pt-4">
      <InfoTip>
        After connecting your TikTok Pixel test to verify that everything has
        been set up correctly. Using the Chrome Browser? Check out the Link to
        test your Pixel implementation! Testing can also be done using the Test
        Events tool in your{' '}
        <a
          href="https://ads.tiktok.com/help/article/tiktok-pixel-helper-2.0?lang=en"
          target="_blank"
          rel="noreferrer"
        >
          TikTok Pixel Helper
        </a>
      </InfoTip>

      <div className="grid md:grid-cols-2 gap-5">
        <TextField
          label="TikTok Pixel Id"
          value={state.pixelId || ''}
          onChange={(e) => setState((s) => ({ ...s, pixelId: e.target.value }))}
          placeholder="Please enter TikTok Pixel Id"
          required
        />
        <TextField
          label="API Secret (optional)"
          value={state.apiSecret || ''}
          onChange={(e) =>
            setState((s) => ({ ...s, apiSecret: e.target.value }))
          }
          placeholder="Please enter API secret"
        />
        <div />
        <PrimaryButton
          className="max-w-[120px] justify-self-end"
          onClick={submit}
          isLoading={isSaving}
          disabled={!state.pixelId}
        >
          Save
        </PrimaryButton>
      </div>
    </div>
  );
};
